"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function FinalEngagement() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="final-engagement" className="dark bg-background text-foreground relative overflow-hidden py-24 sm:py-32 lg:py-40">
      {}
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-primary/40 via-primary/10 to-background pointer-events-none" />
      
      {}
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(var(--color-primary)_1px,transparent_1px)] bg-[size:24px_24px] opacity-10 pointer-events-none" />

      <div ref={ref} className={`container mx-auto px-4 md:px-6 relative z-10 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        {}
        <div className="relative mb-10 group">
          {}
          <div className="absolute inset-0 -m-6 rounded-full border border-primary/30 animate-[spin_10s_linear_infinite]" />
          <div className="absolute inset-0 -m-10 rounded-full border border-primary/10 animate-[spin_15s_linear_infinite_reverse]" />
          
          <div className="relative bg-card border border-border p-5 rounded-3xl shadow-2xl shadow-primary/20 transition-transform duration-500 group-hover:scale-105">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580361/img/kanha_erp_digital_shield_mascot.png" alt="Kanha ERP Digital Shield Mascot" className="w-24 h-24 md:w-32 md:h-32 object-contain drop-shadow-lg" />
          </div>
        </div>

        {}
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 max-w-4xl text-foreground font-sans">
          Ready for the Next Era of Governance?
        </h2>

        {}
        <p className="text-lg md:text-xl text-muted-foreground mb-12 max-w-2xl mx-auto font-sans">
          Partner with Kanha ERP to modernize your public administration infrastructure with our high-security, comprehensive solutions.
        </p>

        {}
        <Button asChild size="lg" variant="secondary" className="h-16 px-10 text-lg md:text-xl rounded-full font-semibold shadow-[0_0_40px_-10px_var(--color-secondary)] hover:shadow-[0_0_60px_-15px_var(--color-secondary)] transition-all duration-300 hover:-translate-y-1">
          <Link to="#contact">
            Schedule a Free Consultation
            <ArrowRight className="ml-2 size-6" />
          </Link>
        </Button>
      </div>
    </section>;
}